module.exports = __webpack_public_path__ + "img/Bolivia.890c2fd5.svg";